import React, { useState } from "react";

export const Page18 = () => {

const slides = [
  {
    title: "Dono da Mudança (MOC Owner)",
    description:
      "Inicia e conduz o MOC do início ao encerramento, garantindo a realização das análises, aprovações, comunicação, treinamentos e a atualização da documentação, bem como o envolvimento das especialidades necessárias ao longo da mudança.",
    bg: "./img/module1/bg01.png",
  },
  {
    title: "Especialistas Locais (antigos TCTs)",
    description:
      "Avaliam a mudança nos aspectos técnico, de segurança e de processo, apoiando a análise de riscos e as decisões do MOC.",
    bg: "./img/module1/bg03.png",
  },
  {
    title: "Responsável por PPS (PPS Maintainer)",
    description:
      "Avalia mudanças com potencial de impacto na segurança de processos, garantindo que os riscos relevantes sejam identificados e devidamente tratados com base nas informações fornecidas no MOC.",
    bg: "./img/module1/bg04.png",
  },
  {
    title: "Local QA / QM",
    description:
      "Avalia mudanças que possam afetar a qualidade do produto. Garante que a mudança esteja alinhada aos requisitos de qualidade antes da implementação.",
    bg: "./img/module1/bg01.png",
  },
  {
    title: "Gerente de Unidade",
    description:
      "Como responsável pela unidade, aprova a mudança em nível gerencial e estratégico, garantindo seu alinhamento com os objetivos operacionais e empresariais. ",
    bg: "./img/module1/bg03.png",
  },
  {
    title: "Responsável pelo PMF (PMF Clerk)",
    description:
      "Este papel garante que a documentação do processo esteja atualizada e controlada, conforme indicado no MOC. Também é responsável por registrar treinamentos, controlar as comunicações e assegurar a integridade dos registros no PMF.",
    bg: "./img/module1/bg01.png",
  },
  {
    title: "Especialistas Técnicos",
    description:
      "Apoiam a avaliação técnica da mudança. Contribuem com pareceres sobre viabilidade, impactos técnicos e análises de risco em suas áreas de especialidade.",
    bg: "./img/module1/bg04.png",
  },
];

  const [current, setCurrent] = useState(0);

  const next = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const prev = () => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div
      style={{
        minHeight: "calc(100vh - 50px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${slides[current].bg})`,
        transition: "background 0.5s ease",
        color: "white",
        // padding: "40px",
      }}
    >
      <div
        style={{
          display: "flex",
          maxWidth: "1200px",
          width: "100%",
          gap: "40px",
          alignItems: "center",
        }}
      >
        {/* LEFT */}
        <div style={{ flex: 1 }}>
          <h1 style={{ fontSize: "32px", marginBottom: "20px" }}>
            Papéis e Responsabilidades
          </h1>
          <p style={{ opacity: 0.8, lineHeight: 1.6 }}>
            No MOC, diversas funções atuam de maneira coordenada para assegurar que toda alteração seja avaliada, aprovada e implementada com segurança.
          </p>
          <p style={{ opacity: 0.8, lineHeight: 1.6 }}>
            <strong>Conheça cada uma delas:</strong>
          </p>
        </div>

        {/* RIGHT - CASCADE CAROUSEL */}
        <div
          style={{
            flex: 1,
            position: "relative",
            height: "300px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {slides.map((slide, index) => {
            const offset = (index - current + slides.length) % slides.length;

            // controla posição em cascata
            const isActive = offset === 0;
            const isNext = offset === 1;
            const isNext2 = offset === 2;

            let transform = "";
            let zIndex = 0;
            let opacity = 0;

            if (isActive) {
              transform = "translateX(0) scale(1)";
              zIndex = 3;
              opacity = 1;
            } else if (isNext) {
              transform = "translateX(20px) translateY(10px) scale(0.95)";
              zIndex = 2;
              opacity = 0.8;
            } else if (isNext2) {
              transform = "translateX(40px) translateY(20px) scale(0.9)";
              zIndex = 1;
              opacity = 0.6;
            } else {
              return null;
            }

            return (
              <div
                key={index}
                style={{
                  position: "absolute",
                  width: "100%",
                  maxWidth: "400px",
                  minHeight: "270px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  background: "#fff",
                  color: "#333",
                  borderRadius: "16px",
                  padding: "24px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                  transform,
                  transition: "all 0.5s ease",
                  zIndex,
                  opacity,
                }}
              >
                <h3 style={{ marginBottom: "10px" }}>{slide.title}</h3>
                <p style={{ fontSize: "16px", lineHeight: 1.5 }}>
                  {slide.description}
                </p>
              </div>
            );
          })}

          <button onClick={prev} style={arrowStyle("left")}>
            <img src="./img/icon/seta_esquerda.png" alt="Anterior" style={imgStyle} />
          </button>

          <button onClick={next} style={arrowStyle("right")}>
            <img src="./img/icon/seta_direita.png" alt="Próximo" style={imgStyle} />
          </button>

          {/* indicators */}
          <div
            style={{
              position: "absolute",
              bottom: "-30px",
              display: "flex",
              gap: "8px",
            }}
          >
            {slides.map((_, index) => (
              <div
                key={index}
                onClick={() => setCurrent(index)}
                style={{
                  width: current === index ? "12px" : "10px",
                  height: current === index ? "12px" : "10px",
                  borderRadius: "50%",
                  background: current === index ? "#fff" : "rgba(255,255,255,0.4)",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const arrowStyle = (side) => ({
  position: "absolute",
  top: "50%",
  [side]: "10px",
  transform: "translateY(-50%)",
  background: "rgba(255,255,255,0.2)",
  border: "none",
  borderRadius: "50%",
  width: "40px",
  height: "40px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backdropFilter: "blur(4px)", 
});

const imgStyle = {
  width: "20px",
  height: "20px",
  objectFit: "contain",
};

export default Page18;